import type { FaireProductEntity } from "../../entity_types/product";

export const p_j3m8kpfdsk: FaireProductEntity = {
  token: "p_j3m8kpfdsk",
  type: "product",
  name: "Amazônico Kit Best-Sellers EDP 8x10ml 2025",
  brandToken: "b_pvex8xjvw3",
  brandName: "Granado Rio de Janeiro",
  imageUrl:
    "https://cdn.faire.com/fastly/bd2b6e587156989a6dded683f4bf3a0a19d8bf0c49ee73e0d0803154e16c0167.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/950404082edcb9fc8b6a47d85f5be95196c821926fe79fb392924634a7bdd758.png",
    "https://cdn.faire.com/fastly/1eb5f8a9a7ee19f1f14a3275eb33363e948dfff244cc9a80513ce5f72402da08.png",
    "https://cdn.faire.com/fastly/f7801b3ecadc561a20fdfe2fb90a16ede1664bba9eb8e078e883eef75411a3c2.png",
  ],
  priceDollars: 81,
  description:
    "Granado invites you to explore the brand’s most iconic creations with the Best-Sellers Suitcase, a curated set featuring some of Granado’s top-selling Eau de Parfums in convenient travel sizes.",
  tags: [],
  msrpDollars: 162,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
